import { useEffect, useState } from 'react';
import { message } from 'antd';
import { Link } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import Paragraph from 'antd/lib/typography/Paragraph';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { WebApiMemberDtoMemberCommunicationHistory } from '../../Repository/eventbookyapi';
import { MemberService } from '../../Services/MemberService';
import { TextService } from '../../Services/TextService';
import CommunicationHistoryTable from './CommunicationHistoryTable';
import LeftMenuCommunicate from './LeftCommunicate';

const AdminCommunicationHistory = () => {
    const [history, setHistory] = useState([] as WebApiMemberDtoMemberCommunicationHistory[]);
    const [isLoading, setIsLoading] = useState(false);
    const GetText = TextService.GetText;

    useEffect(() => {
        const loadCommunicationHistory = async () => {
            setIsLoading(true);

            try {
                const communicationHistory = await MemberService.GetCommunicationHistory();
                const sortedHistory = [...(communicationHistory || [])].sort(
                    (a, b) => new Date(b.sent || 0).getTime() - new Date(a.sent || 0).getTime()
                );
                setHistory(sortedHistory);
            } catch {
                message.error(TextService.GetText('CommunicationHistory_LoadFailed'));
                setHistory([]);
            }

            setIsLoading(false);
        };

        loadCommunicationHistory();
    }, []);

    return <LayoutLeftMenu
        title={GetText('CommunicationHistory_MenuTitle')}
        menu={<LeftMenuCommunicate selected={'communicationArchive'} />}
    >
        <Paragraph>
            {GetText('CommunicationHistory_Description')}{' '}
            <Link to={"/" + getCurrentLanguage() + "/emailFollowUp#followup"}>
                {GetText('CommunicationHistory_GoToPage').replace('{0}', 'E-post/sms uppföljning')}
            </Link>
        </Paragraph>
        <CommunicationHistoryTable history={history} isLoading={isLoading} />
    </LayoutLeftMenu>;
};

export default AdminCommunicationHistory;